/* eslint-disable react/display-name */
import React from 'react';
import cx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import InformationCard from 'components/@common/Cards/InformationCard';
import theme from 'themes/default';
import { ActionOption } from 'types';
import LazyLoadingList from '../ListUtilities/LazyLoadingList';

const useStyles = makeStyles(() => ({
  container: {
    display: 'grid',
    gridGap: 24,
    gridTemplateColumns: `repeat(auto-fill, minmax(327px, 1fr))`,
    gridAutoFlow: 'dense'
  },
  padding: {
    padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`
  },
  itemExpanded: {
    gridRow: 'span 4'
  }
}));

export interface BaseCardData {
  title: string;
  id: number;
  classroomId: number;
  organizationId: number;
  onClick?: any; // TODO
  ContentComponent: React.ReactNode;
  ExpansionComponent?: React.ReactNode;
  color?: string;
}

export interface TileViewContainerProps {
  disablePadding?: true;
  cardData?: Array<BaseCardData>;
  actionOptions?: Array<ActionOption>;
  defaultExpansionComponent?: React.ReactNode;
  children?: React.ReactNode; //Children can be passed instead of or with card data.
}

const TileViewContainer: React.FC<TileViewContainerProps> = ({
  cardData: data,
  disablePadding,
  actionOptions,
  defaultExpansionComponent = null,
  children
}) => {
  const classes = useStyles();
  const [expandedCard, setExpandedCard] = React.useState<number | null>(null);
  const openCard = React.useCallback(
    (index: number) => {
      setExpandedCard(index);
    },
    [setExpandedCard]
  );

  const closeCard = React.useCallback(() => {
    setExpandedCard(null);
  }, [setExpandedCard]);

  return (
    <div className={cx(classes.container, { [classes.padding]: !disablePadding })}>
      <LazyLoadingList
        data={data}
        limit={50}
        renderItem={({ index, item }) => (
          <InformationCard
            onClick={item.onClick}
            id={item.id}
            key={item.id}
            index={index}
            expanded={expandedCard === index}
            openCard={openCard}
            closeCard={closeCard}
            cardTitle={item.title || ''}
            borderColor={item.color}
            Contents={item.ContentComponent}
            actionOptions={actionOptions?.filter(x =>
              x.isPrivileged
                ? x.isPrivileged({
                    classroomId: item.classroomId,
                    organizationId: item.organizationId
                  })
                : true
            )}
          >
            {(defaultExpansionComponent || item.ExpansionComponent) && (
              <div>{item.ExpansionComponent || defaultExpansionComponent}</div>
            )}
          </InformationCard>
        )}
      />
      {children}
    </div>
  );
};

export default TileViewContainer;
